import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "/admin",
    component: () => import("@/layouts/BackLayout.vue"),
    children: [
      {
        path: "",
        name: "AdminDashboard",
        component: () => import("@/views/backend/Dashboard.vue"),
      },
      {
        path: "settings",
        name: "AdminSettings",
        component: () => import("@/views/backend/AdminSettings.vue"),
      },
      {
        path: "frontManage/categoryManage",
        name: "CategoryManage",
        component: () =>
          import("@/views/backend/frontManage/CategoryManage.vue"),
        meta: { title: "分类管理" },
      },
      {
        path: "frontManage/carouselManage",
        name: "CarouselManage",
        component: () =>
          import("@/views/backend/frontManage/CarouselManage.vue"),
        meta: { title: "轮播图管理" },
      },
      {
        path: "frontManage/commodityManage",
        name: "CommodityManage",
        component: () =>
          import("@/views/backend/frontManage/CommodityManage.vue"),
        meta: { title: "商品管理" },
      },
      {
        path: "frontManage/settingManage",
        name: "SettingManage",
        component: () =>
          import("@/views/backend/frontManage/SettingManage.vue"),
        meta: { title: "前台设置" },
      },
      {
        path: "frontManage/noticeManage",
        name: "NoticeManage",
        component: () =>
          import("@/views/backend/frontManage/NoticeManage.vue"),
        meta: { title: "公告管理" },
      },
      {
        path: "frontManage/messageManage",
        name: "MessageManage",
        component: () =>
          import("@/views/backend/frontManage/MessageManage.vue"),
        meta: { title: "留言管理" },
      },
      {
        path: "userManage",
        name: "UserManage",
        component: () => import("@/views/backend/userManage/UserManage.vue"),
        meta: { title: "用户管理" },
      },
    ],
  },
  {
    path: "/admin/login",
    name: "AdminLogin",
    component: () => import("@/views/backend/AdminLogin.vue"),
  },
  {
    path: "/",
    component: () => import("@/layouts/FrontLayout.vue"),
    children: [
      {
        path: "",
        name: "Home",
        component: () => import("@/views/frontend/Home.vue"),
      },
      {
        path: "about",
        name: "About",
        component: () => import("@/views/frontend/About.vue"),
      },
      {
        path: "news",
        name: "News",
        component: () => import("@/views/frontend/News.vue"),
      },
      {
        path: "product",
        name: "Product",
        component: () => import("@/views/frontend/Product.vue"),
      },
      {
        path: "contact",
        name: "Contact",
        component: () => import("@/views/frontend/Contact.vue"),
      },
      {
        path: "notice",
        name: "Notice",
        component: () => import("@/views/frontend/Notice.vue"),
      },
      {
        path: "notice/detail/:id",
        name: "NoticeDetail",
        component: () => import("@/views/frontend/NoticeDetail.vue"),
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/frontend/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 登录守卫（示例）
router.beforeEach((to, from, next) => {
  const isLoggedIn = !!localStorage.getItem("admin_token");
  if (to.path.startsWith("/admin") && to.name !== "AdminLogin" && !isLoggedIn) {
    next({ name: "AdminLogin" });
  } else {
    next();
  }
});

export default router;
